@if (!inline) {
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">
      {{ titleModal | translate }}
    </h5>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>
}

@if (agentModalForm) {
  <form
    autocomplete="off"
    class="form theme-form"
    [formGroup]="agentModalForm"
    (ngSubmit)="onSubmit()">
    <div [class.modal-body]="!inline">
      <div class="row g-2">
        @if (isSectionVisible(AgentDetailTab.PERSONAL)) {
          @if (!inline) {
            <h5 class="mb-0 mt-3 mt-3">
              {{ 'agents.agent.personalInfo.personalInfo' | translate }}
            </h5>
            <hr />
          }

          <ng-container *ngTemplateOutlet="sensitiveNotice"></ng-container>

          <div class="col-md-6 col-lg-4">
            <div class="form-group" appRequiredAsterisk>
              <label for="firstName" class="form-label">
                {{ 'userManagement.users.firstName' | translate }}
              </label>
              <input type="text" id="firstName" formControlName="firstName" class="form-control" />
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="form-group" appRequiredAsterisk>
              <label for="lastName" class="form-label">
                {{ 'userManagement.users.lastName' | translate }}
              </label>
              <input type="text" id="lastName" formControlName="lastName" class="form-control" />
            </div>
          </div>

          <div class="col-md-6 col-lg-4" appRequiredAsterisk>
            <label for="documentNumber" class="form-label">
              {{ 'agents.agent.personalInfo.dni' | translate }}
              <ng-container *ngTemplateOutlet="sensitiveLock"></ng-container>
            </label>
            <input
              type="text"
              id="documentNumber"
              formControlName="documentNumber"
              class="form-control" />
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="birthCountryId" class="form-label">
                {{ 'words.birthcountry' | translate }}
                <span class="text-danger">*</span>
              </label>
              <ng-select
                id="birthCountryId"
                formControlName="birthCountryId"
                [items]="birthCountries$ | async"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [notFoundText]="'words.noItemsFound' | translate"
                (search)="onSearchSelect(NG_SELECT_QUERIES.BIRTH_COUNTRIES, $event.term)"
                (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.BIRTH_COUNTRIES)"
                (change)="onBirthCountryChange($event)">
                <ng-template ng-option-tmp let-item="item">
                  @if (item.icon) {
                    <i class="flag-icon flag-icon-{{ item.icon | lowercase }} m-r-5 "></i>
                  }
                  <span>{{ item.label }}</span>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  @if (item.icon) {
                    <i class="flag-icon flag-icon-{{ item.icon | lowercase }} m-r-5"></i>
                  }
                  <span>{{ item.label }}</span>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="birthCityId" class="form-label">
                {{ 'words.birthcity' | translate }}
                <span class="text-danger">*</span>
              </label>
              <ng-select
                id="birthCityId"
                formControlName="birthCityId"
                [items]="birthCities$ | async"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [notFoundText]="'words.noItemsFound' | translate"
                (search)="onSearchSelect(NG_SELECT_QUERIES.BIRTH_CITIES, $event.term)"
                (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.BIRTH_CITIES)">
              </ng-select>
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="birthDate" class="form-label">
                {{ 'agents.agent.personalInfo.birthDate' | translate }}
                <ng-container *ngTemplateOutlet="sensitiveLock"></ng-container>
                <span class="text-danger">*</span>
              </label>
              <input type="date" id="birthDate" formControlName="birthDate" class="form-control" />

              <shared-form-field-error
                [control]="agentModalForm.get('birthDate')"
                [errorMessages]="{
                  underage: 'words.mustBeAdult',
                  required: 'words.requiredField',
                }">
              </shared-form-field-error>
            </div>
          </div>

          <div class="col-md-6 col-lg-8">
            <div class="form-group">
              <label for="address" class="form-label">
                {{ 'userManagement.users.address' | translate }}
                <ng-container *ngTemplateOutlet="sensitiveLock"></ng-container>
              </label>
              <input type="text" id="address" formControlName="address" class="form-control" />
            </div>
          </div>

          <div class="col-md-6 col-lg-4" appRequiredAsterisk>
            <label for="gender" class="form-label">
              {{ 'players.player.gender' | translate }}
            </label>
            <ng-select
              id="gender"
              formControlName="gender"
              [items]="genders$ | async"
              bindLabel="label"
              bindValue="value">
              <ng-template ng-option-tmp let-item="item">
                {{ item.label | translate }}
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                {{ item.label | translate }}
              </ng-template></ng-select
            >
          </div>
        }

        @if (isSectionVisible(AgentDetailTab.CONTACT)) {
          @if (!inline) {
            <h5 class="mb-0 mt-3 mt-3">
              {{ 'agents.agent.contactInfo.contactInfo' | translate }}
            </h5>
            <hr />
          }

          <ng-container *ngTemplateOutlet="sensitiveNotice"></ng-container>

          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label for="email" class="form-label">
                {{ 'userManagement.users.email' | translate }}
                <ng-container *ngTemplateOutlet="sensitiveLock"></ng-container>
                <span class="text-danger">*</span>
              </label>
              <input type="email" id="email" formControlName="email" class="form-control" />

              <shared-form-field-error
                [control]="agentModalForm.get('email')"
                [errorMessages]="{
                  email: 'words.invalidEmail',
                  required: 'words.requiredField',
                }">
              </shared-form-field-error>
            </div>
          </div>

          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label for="conventionalNumber" class="form-label">
                {{ 'userManagement.users.conventionalNumber' | translate }}
                <ng-container *ngTemplateOutlet="sensitiveLock"></ng-container>
              </label>
              <input
                type="text"
                id="conventionalNumber"
                formControlName="conventionalNumber"
                class="form-control"
                onlyNumbers />
            </div>
          </div>

          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label for="telephoneCodeId" class="form-label">
                {{ 'userManagement.users.telephoneCode' | translate }}
                <span class="text-danger">*</span>
              </label>
              <ng-select
                id="telephoneCodeId"
                formControlName="telephoneCodeId"
                [items]="countriesWithPhoneCodes$ | async"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [notFoundText]="'words.noItemsFound' | translate"
                (search)="onSearchSelect(NG_SELECT_QUERIES.TELEPHONE_CODES, $event.term)"
                (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.TELEPHONE_CODES)"></ng-select>
            </div>
          </div>

          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label for="mobileNumber" class="form-label">
                {{ 'userManagement.users.mobileNumber' | translate }}
                <ng-container *ngTemplateOutlet="sensitiveLock"></ng-container>
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                id="mobileNumber"
                formControlName="mobileNumber"
                class="form-control"
                (keypress)="validateKeypress($event)"
                (paste)="validatePaste($event)" />

              <shared-form-field-error
                [control]="agentModalForm.get('mobileNumber')"
                [errorMessages]="{
                  invalidPhoneNumber: 'words.invalidPhoneNumber',
                  required: 'words.requiredField',
                }">
              </shared-form-field-error>
            </div>
          </div>

          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label for="whatsappCodeId" class="form-label">
                {{ 'userManagement.users.telephoneCodeWhatsapp' | translate }}
                <i class="fa fa-whatsapp"></i>
              </label>
              <ng-select
                id="whatsappCodeId"
                formControlName="whatsappCodeId"
                [items]="countriesWithPhoneCodes$ | async"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="true"
                [notFoundText]="'words.noItemsFound' | translate"
                (search)="onSearchSelect(NG_SELECT_QUERIES.TELEPHONE_CODES, $event.term)"
                (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.TELEPHONE_CODES)"></ng-select>
            </div>
          </div>

          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label for="whatsappNumber" class="form-label">
                {{ 'userManagement.users.whatsappNumber' | translate }}
                <i class="fa fa-whatsapp"></i>
                <ng-container *ngTemplateOutlet="sensitiveLock"></ng-container>
              </label>
              <input
                type="text"
                id="whatsappNumber"
                formControlName="whatsappNumber"
                class="form-control"
                (keypress)="validateKeypress($event)"
                (paste)="validatePaste($event)" />
            </div>
          </div>

          @if (
            agentModalForm.hasError('whatsappDependency') &&
            agentModalForm.get('whatsappCodeId')?.value
          ) {
            <div class="col-12">
              <div class="alert alert-danger">
                {{ 'words.requiredField' | translate }}
                {{ 'userManagement.users.whatsappNumber' | translate }}
              </div>
            </div>
          }

          @if (
            agentModalForm.hasError('whatsappDependency') &&
            agentModalForm.get('whatsappNumber')?.value
          ) {
            <div class="col-12">
              <div class="alert alert-danger">
                {{ 'words.requiredField' | translate }}
                {{ 'userManagement.users.telephoneCodeWhatsapp' | translate }}
              </div>
            </div>
          }
        }

        @if (isSectionVisible(AgentDetailTab.AGENCY)) {
          @if (!inline) {
            <h5 class="mb-0 mt-3">
              {{ 'agents.agent.agencyInfo.agencyInfo' | translate }}
            </h5>
            <hr />
          }

          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="username" class="form-label">
                {{ 'userManagement.users.username' | translate }}
                <span class="text-danger">*</span>
              </label>
              <i
                class="fa fa-info-circle text-secondary mx-1"
                ngbTooltip="{{ 'agents.agent.usernameInfo' | translate }}"
                tooltipClass="custom-tooltip"></i>
              <input type="text" id="username" formControlName="username" class="form-control" />

              <shared-form-field-error
                [control]="agentModalForm.get('username')"
                [errorMessages]="{
                  pattern: 'words.usernameError',
                  required: 'words.requiredField',
                }">
              </shared-form-field-error>
            </div>
          </div>

          @if (activeButtonAction === BUTTON_ACTIONS.ADD) {
            <div class="col-md-6 col-lg-4">
              <div class="form-group password-wrapper password-wrapper-70">
                <label for="password" class="form-label">
                  {{ 'userManagement.users.password' | translate }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  id="password"
                  formControlName="password"
                  class="form-control" />
                <i
                  class="fas"
                  [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"
                  (click)="togglePasswordVisibility()"></i>
              </div>

              <shared-form-field-error
                [control]="agentModalForm.get('password')"
                [errorMessages]="{
                  strongPassword: 'words.passwordWeak',
                  required: 'words.requiredField',
                }">
              </shared-form-field-error>
            </div>
          }

          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="countryId" class="form-label">
                {{ 'words.country' | translate }} <span class="text-danger">*</span>
              </label>
              <ng-select
                id="countryId"
                formControlName="countryId"
                [items]="countries$ | async"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [notFoundText]="'words.noItemsFound' | translate"
                (search)="onSearchSelect(NG_SELECT_QUERIES.COUNTRIES, $event.term)"
                (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.COUNTRIES)"
                (change)="onCountryChange($event)">
                <ng-template ng-option-tmp let-item="item">
                  @if (item.icon) {
                    <i class="flag-icon flag-icon-{{ item.icon | lowercase }} m-r-5 "></i>
                  }
                  <span>{{ item.label }}</span>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  @if (item.icon) {
                    <i class="flag-icon flag-icon-{{ item.icon | lowercase }} m-r-5"></i>
                  }
                  <span>{{ item.label }}</span>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="cityId" class="form-label">
                {{ 'words.city' | translate }} <span class="text-danger">*</span>
              </label>
              <ng-select
                id="cityId"
                formControlName="cityId"
                [items]="cities$ | async"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [notFoundText]="'words.noItemsFound' | translate"
                (search)="onSearchSelect(NG_SELECT_QUERIES.CITIES, $event.term)"
                (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.CITIES)">
              </ng-select>
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="currencyId" class="form-label">
                {{ 'words.currency' | translate }}
              </label>
              <ng-select
                id="currencyId"
                formControlName="currencyId"
                [items]="currencies$ | async"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [notFoundText]="'words.noItemsFound' | translate"
                (search)="onSearchSelect(NG_SELECT_QUERIES.CURRENCIES, $event.term)"
                (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.CURRENCIES)">
              </ng-select>
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="roleId" class="form-label">
                {{ 'userManagement.users.role' | translate }}
                <span class="text-danger">*</span>
              </label>
              <ng-select
                id="roleId"
                formControlName="roleId"
                [items]="roles$ | async"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [notFoundText]="'words.noItemsFound' | translate"
                (change)="onRoleChange($event)"
                (search)="onSearchSelect(NG_SELECT_QUERIES.USER_ROLES, $event.term)"
                (clear)="onSearchSelect(NG_SELECT_QUERIES.USER_ROLES)"
                (close)="onSearchSelect(NG_SELECT_QUERIES.USER_ROLES)"
                (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.USER_ROLES)">
              </ng-select>
              <shared-form-field-error
                [control]="agentModalForm.get('roleId')"
                [errorMessages]="{ required: 'words.requiredField' }" />
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="languageId" class="form-label">
                {{ 'words.language' | translate }}
                <span class="text-danger">*</span>
              </label>
              <ng-select
                id="languageId"
                formControlName="languageId"
                [items]="languages$ | async"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [notFoundText]="'words.noItemsFound' | translate"
                (search)="onSearchSelect(NG_SELECT_QUERIES.LANGUAGE, $event.term)"
                (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.LANGUAGE)">
              </ng-select>
            </div>
          </div>

          @if (isPhysicalCashRole) {
            @if (!inline) {
              <h5 class="mb-0 mt-3">
                {{ 'agents.agent.physicalCash.physicalCash' | translate }}
              </h5>
              <hr />
            }

            <div class="col-md-6 col-lg-6">
              <div class="form-group" appRequiredAsterisk>
                <label for="localName" class="form-label">
                  {{ 'agents.agent.physicalCash.localName' | translate }}
                </label>
                <input
                  type="text"
                  id="localName"
                  formControlName="localName"
                  class="form-control" />
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label for="localPhone" class="form-label">
                  {{ 'agents.agent.physicalCash.localPhone' | translate }}
                </label>
                <input
                  type="text"
                  id="localPhone"
                  formControlName="localPhone"
                  class="form-control"
                  (keypress)="validateKeypress($event)"
                  (paste)="validatePaste($event)" />
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label for="localWhatsappCodeId" class="form-label">
                  {{ 'userManagement.users.telephoneCodeWhatsapp' | translate }}
                  <i class="fa fa-whatsapp"></i>
                </label>
                <ng-select
                  id="localWhatsappCodeId"
                  formControlName="localWhatsappCodeId"
                  [items]="countriesWithPhoneCodes$ | async"
                  [bindLabel]="'label'"
                  [bindValue]="'value'"
                  [clearable]="true"
                  [notFoundText]="'words.noItemsFound' | translate"
                  (search)="onSearchSelect(NG_SELECT_QUERIES.TELEPHONE_CODES, $event.term)"
                  (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.TELEPHONE_CODES)"></ng-select>
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label for="localWhatsappNumber" class="form-label">
                  {{ 'agents.agent.physicalCash.localWhatsappNumber' | translate }}
                  <i class="fa fa-whatsapp"></i>
                </label>
                <input
                  type="text"
                  id="localWhatsappNumber"
                  formControlName="localWhatsappNumber"
                  class="form-control"
                  (keypress)="validateKeypress($event)"
                  (paste)="validatePaste($event)" />
              </div>
            </div>

            @if (
              agentModalForm.hasError('localWhatsappDependency') &&
              agentModalForm.get('localWhatsappCodeId')?.value
            ) {
              <div class="col-12">
                <div class="alert alert-danger">
                  {{ 'words.requiredField' | translate }}
                  {{ 'agents.agent.physicalCash.localWhatsappNumber' | translate }}
                </div>
              </div>
            }

            @if (
              agentModalForm.hasError('localWhatsappDependency') &&
              agentModalForm.get('localWhatsappNumber')?.value
            ) {
              <div class="col-12">
                <div class="alert alert-danger">
                  {{ 'words.requiredField' | translate }}
                  {{ 'userManagement.users.telephoneCodeWhatsapp' | translate }}
                </div>
              </div>
            }

            <div class="col-md-6 col-lg-8">
              <div class="form-group" appRequiredAsterisk>
                <label for="localAddress" class="form-label">
                  {{ 'agents.agent.physicalCash.localAddress' | translate }}
                </label>
                <input
                  type="text"
                  id="localAddress"
                  formControlName="localAddress"
                  class="form-control" />
              </div>
            </div>

            <div class="col-md-6 col-lg-4">
              <div class="form-group" appRequiredAsterisk>
                <label for="localMapLink" class="form-label">
                  {{ 'agents.agent.physicalCash.localMapLink' | translate }}
                </label>
                <input
                  type="url"
                  id="localMapLink"
                  formControlName="localMapLink"
                  class="form-control" />
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group" appRequiredAsterisk>
                <label for="localOpeningTime" class="form-label">
                  {{ 'agents.agent.physicalCash.localOpeningTime' | translate }}
                </label>
                <input
                  type="time"
                  id="localOpeningTime"
                  formControlName="localOpeningTime"
                  class="form-control" />
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group" appRequiredAsterisk>
                <label for="localClosingTime" class="form-label">
                  {{ 'agents.agent.physicalCash.localClosingTime' | translate }}
                </label>
                <input
                  type="time"
                  id="localClosingTime"
                  formControlName="localClosingTime"
                  class="form-control" />
              </div>
            </div>
          }

          @if (activeButtonAction !== BUTTON_ACTIONS.ADD) {
            <div class="col-md-6 col-lg-4">
              <div class="form-group">
                <label for="createdAt" class="form-label">
                  {{ 'words.createdAt' | translate }}
                </label>
                <input
                  type="text"
                  id="createdAt"
                  class="form-control"
                  [disabled]="true"
                  [value]="createdAt | date: FORMAT_FOR_DATES" />
              </div>
            </div>

            <div class="col-md-6 col-lg-4">
              <div class="form-group">
                <label for="updatedAt" class="form-label">
                  {{ 'words.updatedAt' | translate }}
                </label>
                <input
                  type="text"
                  id="updatedAt"
                  class="form-control"
                  [disabled]="true"
                  [value]="updatedAt | date: FORMAT_FOR_DATES" />
              </div>
            </div>

            <div class="col-12">
              <div class="d-flex flex-wrap gap-2 gap-lg-4">
                <div class="d-flex align-items-center gap-2">
                  <label for="TFA" class="col-form-label">
                    {{ 'userManagement.users.twoFactorAuthentication' | translate }}
                  </label>
                  <div class="d-flex switch-md icon-state">
                    <label class="switch m-0">
                      <input type="checkbox" id="TFA" formControlName="TFA" />
                      <div class="switch-state"></div>
                    </label>
                  </div>
                </div>

                <div class="d-flex align-items-center gap-2">
                  <label for="state" class="col-form-label">
                    {{ 'userManagement.users.state' | translate }}
                  </label>
                  <div class="d-flex switch-md icon-state">
                    <label class="switch m-0">
                      <input type="checkbox" id="state" formControlName="state" />
                      <div class="switch-state"></div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          }
        }

        @if (isSectionVisible(AgentDetailTab.COMMISSIONS)) {
          @if (!inline) {
            <h5 class="mb-0 mt-3">
              {{ 'agents.agent.commissions.title' | translate }}
            </h5>
            <hr />
          }

          <div class="col-12">
            <div class="d-flex flex-wrap justify-content-between align-items-center gap-3 py-3 border-bottom">
              <div>
                <label for="comissionPlanId" class="form-label fw-semibold mb-1">
                  {{ 'agents.agent.commissions.ngrCommission' | translate }}
                  <span class="text-danger">*</span>
                </label>
                <span class="f-light f-12 d-block">
                  {{ 'agents.agent.commissions.ngrCommissionInfo' | translate }}
                </span>
              </div>
              <div class="col-12 col-sm-6 col-md-4">
                <ng-select
                  id="comissionPlanId"
                  formControlName="comissionPlanId"
                  [items]="commissionPlans$ | async"
                  [bindLabel]="'label'"
                  [bindValue]="'value'"
                  [clearable]="false"
                  [notFoundText]="'words.noItemsFound' | translate"
                  (search)="onSearchSelect(NG_SELECT_QUERIES.COMISSION_PLANS, $event.term)"
                  (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.COMISSION_PLANS)">
                </ng-select>
              </div>
            </div>

            <div
              class="d-flex flex-wrap justify-content-between align-items-center gap-3 py-3"
              formGroupName="transactionCommission">
              <div>
                <label class="form-label fw-semibold mb-1" for="transactionCommissionEnabled">
                  {{ 'agents.agent.transactionCommission.transactionCommission' | translate }}
                </label>
                <span class="f-light f-12 d-block">
                  {{ 'agents.agent.transactionCommission.description' | translate }}
                </span>
              </div>
              <div class="d-flex align-items-center gap-2">
                <div class="d-flex switch-md icon-state">
                  <label class="switch m-0">
                    <input
                      type="checkbox"
                      id="transactionCommissionEnabled"
                      formControlName="enabled" />
                    <div class="switch-state"></div>
                  </label>
                </div>
                <span
                  class="fw-semibold"
                  [class.text-success]="
                    agentModalForm.get('transactionCommission.enabled')?.value
                  ">
                  {{
                    (agentModalForm.get('transactionCommission.enabled')?.value
                      ? 'agents.agent.transactionCommission.active'
                      : 'agents.agent.transactionCommission.inactive'
                    ) | translate
                  }}
                </span>
              </div>
            </div>

            <div class="border rounded px-3 mt-3 mb-2" formGroupName="transactionCommission">
              <div
                class="d-flex flex-wrap justify-content-between align-items-center gap-3 py-3 border-bottom">
                <label for="depositRate" class="form-label mb-0">
                  {{ 'agents.agent.transactionCommission.depositRate' | translate }}
                </label>
                <div class="col-12 col-sm-6 col-md-4">
                  <div class="input-group">
                    <input
                      type="text"
                      id="depositRate"
                      formControlName="depositRate"
                      class="form-control"
                      placeholder="0"
                      appOnlyNumbersWhitTwoDecimal />
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-wrap justify-content-between align-items-center gap-3 py-3">
                <label for="withdrawalRate" class="form-label mb-0">
                  {{ 'agents.agent.transactionCommission.withdrawalRate' | translate }}
                </label>
                <div class="col-12 col-sm-6 col-md-4">
                  <div class="input-group">
                    <input
                      type="text"
                      id="withdrawalRate"
                      formControlName="withdrawalRate"
                      class="form-control"
                      placeholder="0"
                      appOnlyNumbersWhitTwoDecimal />
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        @if (isSectionVisible(AgentDetailTab.REFERRED)) {
          @if (!inline) {
            <h5 class="mb-0 mt-3 mt-3">
              {{ 'agents.agent.personalInfo.referredUser' | translate }}
            </h5>
            <hr />
          }

          @if (referredControls.length === 0) {
            <p class="bank-meta text-center my-3">
              {{ 'agents.agent.personalInfo.anyReferred' | translate }}
            </p>
          }

          <div formArrayName="referred">
            <div
              *ngFor="let referred of referredControls; let i = index"
              [formGroupName]="i"
              class="row g-2">
              <div class="col-md">
                <label for="referralId" class="form-label">
                  {{ 'agents.agent.personalInfo.referredUser' | translate }}
                </label>
                <ng-select
                  id="referralId"
                  formControlName="referralId"
                  [items]="users$ | async"
                  [bindLabel]="'label'"
                  [bindValue]="'value'"
                  [clearable]="true"
                  [notFoundText]="'words.noItemsFound' | translate"
                  (search)="onSearchSelect(NG_SELECT_QUERIES.USERS, $event.term)"
                  (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.USERS)">
                </ng-select>
              </div>

              <div class="col-md">
                <label for="percentage" class="form-label">
                  {{ 'agents.agent.personalInfo.percentage' | translate }}
                </label>
                <ng-select
                  formControlName="percentage"
                  [items]="referalPercentages$ | async"
                  [bindLabel]="'label'"
                  [bindValue]="'value'"
                  [clearable]="true"
                  [notFoundText]="'words.noItemsFound' | translate"
                  (search)="onSearchSelect(NG_SELECT_QUERIES.PERCENTAGES, $event.term)"
                  (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.PERCENTAGES)">
                </ng-select>
              </div>
              @if (activeButtonAction !== BUTTON_ACTIONS.VIEW) {
                <div class="col-md-auto d-flex align-items-end">
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    ngbTooltip="{{ 'agents.agent.personalInfo.removeReferred' | translate }}"
                    *ngIf="i >= 1"
                    (click)="removeReferred(i)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              }
            </div>
          </div>

          @if (activeButtonAction !== BUTTON_ACTIONS.VIEW) {
            <div class="row mt-3">
              <div class="col-md-12 d-flex justify-content-center">
                <button type="button" class="btn btn-outline-primary" (click)="addReferred()">
                  <i class="fa fa-plus me-1" aria-hidden="true"></i>
                  {{ 'agents.agent.personalInfo.addReferred' | translate }}
                </button>
              </div>
            </div>
          }
        }
      </div>
    </div>

    @if (inline && !readonly) {
      <div class="d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn btn-danger" (click)="cancelEdit()">
          {{ 'btn.cancel' | translate }}
        </button>
        <button type="submit" class="btn btn-secondary">
          {{ 'btn.save' | translate }}
        </button>
      </div>
    } @else if (activeButtonAction !== BUTTON_ACTIONS.VIEW) {
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="closeModal()">
          {{ 'btn.cancel' | translate }}
        </button>
        <button type="submit" class="btn btn-secondary" [disabled]="agentModalForm.invalid">
          {{ 'btn.save' | translate }}
        </button>
      </div>
    }
  </form>
}

<ng-template #sensitiveLock>
  @if (isSensitiveLocked) {
    <span class="sensitive-lock ms-1">
      <shared-feather-icons [icon]="'lock'"></shared-feather-icons>
    </span>
  }
</ng-template>

<ng-template #sensitiveNotice>
  @if (isSensitiveLocked) {
    <div class="col-12">
      <div class="sc-notice sensitive-notice m-0">
        <shared-feather-icons [icon]="'info'"></shared-feather-icons>
        <span>{{ 'agents.agent.sensitiveDataLockedNotice' | translate }}</span>
      </div>
    </div>
  }
</ng-template>
